<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain class="pb-0" maxwidth-container="700px">
      <CartoesStepper />
    </InternaMain>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import CartoesStepper from '@/components/MeuPerfil/CartoesCredito/CartoesStepper.vue';

export default {
  name: 'CartoesCreditoCadastrar',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    CartoesStepper,
  },

  data() {
    return {
    };
  },
};
</script>
